<template>
  <div>
    <!---->
    <div class="wrap-programme">
      <div class="container">
        <div id="content">
          <div id="options" class="clearfix combo-filters">
            <div class="option-combo topic topic-block">
              <ul class="filter option-set clearfix " data-filter-group="topic">
                <li v-on:click="getAllAgendaList()">
                  <a v-bind:class="{ 'selected': selectedCategory === 'all' }" data-filter-value="">All</a>
                </li>
                <li v-for="category in categoryList" v-bind:key="category.id"
                  v-on:click="showAgendaByCategoryAndDay(category.category)">
                  <a data-filter-value="" :class="{ 'selected': category.category === selectedCategory }">{{
                    category.category }}</a>
                </li>
              </ul>
            </div>
            <div class="option-combo date-filter date-filter-block">
              <img class="filter-block-logo"
                src="https://www.hydrogenexpo.com/media/11004/worley_logo_2019_1000x303_rgb_white.png" alt="Worley Logo">

              <ul class="filter option-set clearfix filter-slider slick-initialized slick-slider"
                data-filter-group="date-filter">

                <li v-for="day in days" v-bind:key="day.id" v-on:click="showAgendaByDay(day.startDate)">
                  <a :id="day.startDate" :class="{ 'test tc-agenda-day-active': day.startDate === currentHashId }">
                    <span class="b-filter">{{ day.dayname + " " }}</span>{{ formatDateToMonthDayYear(day.startDateFormatted) }}
                  </a>
                </li>

              </ul>
            </div>
          </div>
          <div id="container" class="clearfix shedule-outer isotope" v-for="agendas in groupAgendaByTime(agendaList)"
            v-bind:key="agendas[0].startTime" v-bind:class="'agendas-' + agendas[0].id">
            <div class="timetable int-timetable-next">
              <div class="subject-list"
              :class="{ 'subject-list-fullwidth': (agendas[0].category === null && agendas[0].room === null)}"
                >
                <div
                  class="time-shedule filter-shape production tue isotope-item isotope-item-show isotope-item-show-first">
                  <ul>
                    <li>
                      <span class="alarm-time"></span>
                      {{ agendas[0].startTime }}
                    </li>
                  </ul>
                </div>
                <div class="filter-shape tue production isotope-item" v-for="agenda in agendas" v-bind:key="agenda.Id">
                  <div class="subject-block">
                    <hr :id="'id-' + agenda.Id" :class="'id-' + agenda.Id + ' pubId-' + agenda.publishedSessionId">
                    <div class="subject-outer">


                      <h4 class="no-link-head" v-if="agenda.title && agenda.category === null && agenda.room === null"> {{
                        agenda.title }}
                      </h4>


                      <a class="tuesday-fancy common-fancy" v-else>
                        <h4 @click="getagendaDetailsById(agenda.publishedSessionId)" v-if="agenda.title"
                          id="popup-trigger"> {{ agenda.title
                          }}</h4>
                      </a>



                      <div class="tag" v-if="agenda.category">
                        <span class="sub-tag">{{ agenda.category }}</span>
                      </div>
                      <!--new-->
                      <div class="row sponser-row">
                        <div class="container">
                          <span class="nmpr" v-if="agenda.hosted || agenda.assets">Sponsored By:</span>
                          <span v-if="heading" class="heading cmpr">{{ agenda.heading }}</span>
                          <img v-if="agenda.assets" :srcset="agenda.assets">
                          <div class="sp-textpr" v-else>
                            <span class="despr">{{ agenda.hosted }}</span>
                          </div>
                        </div>
                      </div>
                      <p class="description-wrap" v-if="agenda.description !== null & agenda.category !== null" v-html="agenda.description"></p>

                      <div class="sub-loc" v-if="agenda.room !== null & agenda.category !== null">
                        <ul>
                          <li v-if="agenda.room !== null & agenda.category !== null"><img
                              src="https://www.hydrogenexpo.com/images/location.png" alt="location">{{ agenda.room }}
                          </li>
                          <li v-if="agenda.startDate !== null & agenda.category !== null"><img
                              src="https://www.hydrogenexpo.com/images/small-arm.png" alt="small-arm">{{ agenda.startTime
                              }} - {{ agenda.endTime }} </li>
                        </ul>
                      </div>
                      <div class="sub-speaker">
                        <div class="sub-speaker-list">
                          <div class="sub-sp-block" id="spp-29875" v-for="User in agenda.user" v-bind:key="User.Id">
                            <router-link :to="{ name: 'SpeakerDetail', query: { userId: User.id } }">
                              <div class="sp-img">
                                <img v-if="User.avatar == null || User.avatar == 'https://www.dmgeventsconferences.com/'"
                                  src="https://hydrogenexpo.com/media/xiadtpms/deafult-speaker-hydrogen.jpg" alt="">
                                <img v-else :srcset="User.avatar">
                              </div>
                              <div class="sp-text">
                                <span class="nm">{{ User.name }}</span>
                                <span class="des">{{ User.jobTitle }}</span>
                                <span class="cm">{{ User.company }}</span>
                              </div>

                            </router-link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- pop-up start-->
          <div class="pop-up-overlay"  id="popup-overlay" >
            <div class="pop-hide f-library tuesday-fancy exhibit-list-popup">
              <span class="close-btn" id="close-btn"></span>
              <div class="pr-wrap">
                <div class="pr-outer">
                  <div class="pr-calender">
                    <div v-if="dayname || startDateFormatted" class="pr-date">
                      <span class="pr-bold">
                        {{ dayname }}
                      </span>{{ startDateFormatted }}
                    </div>
                    <div class="pr-add-cal"><a href="#" @click="downloadICalendar" class="calender-link yellow-bttn"> Add
                        to
                        calendar </a></div>
                  </div>
                  <div class="pr-content">
                    <div class="pr-tg"> <span v-if="category" class="sub-tag">{{ category }}</span>
                    </div>
                    <h2 v-if="companyName">{{ companyName }}</h2>
                    <div class="pr-location">
                      <ul>
                        <li v-if="room"><img src="https://www.hydrogenexpo.com/images/pr-alarm.png" alt="pr-alarm">{{
                          startTime }} -{{ endTime }} </li>
                        <li v-if="startDate"><img src="https://www.hydrogenexpo.com/images/pr-location.png"
                            alt="pr-location"> {{ room
                            }} </li>
                      </ul>
                    </div>
                    <!--new-->
                    <div class="row sponser-row">
                      <div class="container">
                        <span class="nmpr" v-if="hosted || assets">Sponsored By:</span>
                        <span v-if="heading" class="heading cmpr">{{ heading }}</span>
                        <img v-if="assets" :srcset="assets">
                        <div class="sp-textpr" v-else>
                          <span class="despr">{{ hosted }}</span>
                        </div>
                      </div>
                    </div>



                    <div class="sp-content">
                      <p v-if="description" v-html="removeNbsp(description)"></p>
                    </div>
                  </div>
                </div>
                <div class="pr-sp agenda-slots" v-if="slotsList.length > 0">
                  <h2 v-if="slotsList.length > 0">slots</h2>
                  <div class="slots-content" v-for="slot in slotsList" v-bind:key="slot.Id">
                    <div class="nmpr">{{ slot.title }}</div>
                    <div class="cmpr"> <span class="despr">Type : </span>{{
                      slot.type }}</div>
                    <div class="cmpr"> <span class="despr">Duration : </span>{{ slot.duration }}</div>

                    <!--slot users-->
                    <div class="sub-speakerpr">
                      <div class="sub-speaker-listpr">
                        <div class="sub-sp-blockpr" v-for="slotUser in slot.slotUsers" v-bind:key="slotUser.Id">
                          <div class="sp-imgpr"><img
                              v-if="slotUser.avatar == null || slotUser.avatar == 'https://www.dmgeventsconferences.com/'"
                              src="https://www.hydrogenexpo.com/media/9329/chc-logo.svg" alt=""><img v-else
                              :srcset="slotUser.avatar"> </div>
                          <div class="sp-textpr"> <span class="nmpr">{{ slotUser.name }}</span> <span class="despr">{{
                            slotUser.job_title }}</span> <span class="cmpr">{{ slotUser.company }}</span> </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="pr-sp" v-if="userList.length > 0">
                  <div class="sub-speakerpr">
                    <div class="sub-speaker-listpr">
                      <div class="sub-sp-blockpr" v-for="User in userList" v-bind:key="User.Id">
                        <div class="sp-imgpr"><img
                            v-if="User.avatar == null || User.avatar == 'https://www.dmgeventsconferences.com/'"
                            src="https://www.hydrogenexpo.com/media/9329/chc-logo.svg" alt=""><img v-else
                            :srcset="User.avatar"> </div>
                        <div class="sp-textpr"> <span class="nmpr">{{ User.name }}</span> <span class="despr">{{
                          User.jobTitle }}</span> <span class="cmpr">{{ User.company }}</span> </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> <!--pop-up end-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';
import axios from "axios";
import url from "./../../config/url";
export default {
  name: "ExhibitorList",   data() {
    return {
      days: '',
      categoryList: '', // debugger
      activeDay: null,
      selectedCategory: 'all',
      categoryOrder: [],
    }
  },
  computed: {
    agendaList: function () {
      //debugger
      return this.$store.state.agendalistInitial.exhibitors;
    },
    /*for popup agenda data*/
    companyName: function () {

      return this.$store.state.agendalistInitial.title;
    },
    category: function () {
      return this.$store.state.agendalistInitial.category;
    },
    description: function () {
      return this.$store.state.agendalistInitial.description;
    },
    room: function () {
      return this.$store.state.agendalistInitial.room;
    },

    heading: function () {
      return this.$store.state.agendalistInitial.heading;
    },
    hosted: function () {
      return this.$store.state.agendalistInitial.hosted;
    },
    assets: function () {
      return this.$store.state.agendalistInitial.assets;
    },



    startDate: function () {
      return this.$store.state.agendalistInitial.startDate;
    },
    startTime: function () {
      return this.$store.state.agendalistInitial.startTime;
    },
    endTime: function () {
      return this.$store.state.agendalistInitial.endTime;
    },
    publishedSessionId: function () {
      //debugger
      return this.$store.state.agendalistInitial.publishedSessionId;
    },
    userList: function () {
      return this.$store.state.agendalistInitial.user;
    },
    slotsList: function () {
      //debugger
      return this.$store.state.agendalistInitial.slots;
    },
    dayname: function () {
      return this.$store.state.agendalistInitial.dayname;
    },
    startDateFormatted: function () {
      // debugger
      return this.$store.state.agendalistInitial.startDateFormatted;
    },
    /*for popup agenda data - end*/
    currentHashId() {
      // debugger
      return this.activeDay.startDate;
    }
  },
  mounted() {
    //debugger
    this.categoryOrder = (typeof window !== 'undefined' && window.CategoryOrder) ? window.CategoryOrder : ['Oil and Gas', 'New Energy', 'AI and Data Centres'];
    this.getAllCategoryList();
    this.getAllDayList();
  },
  methods: {
    getAllAgendaList() {
      this.selectedCategory = 'all';
      // Get the current active day
      let selectedDayValue = this.$store.state.dayState;
      if (selectedDayValue == null) {
        selectedDayValue = this.$store.state.dayState1;
  }
  
  // Filter by the current day only (no category filter)
  this.$store.dispatch("agendaFilterByDay", selectedDayValue);

    },
    /*for pop up*/
    getagendaDetailsById(publishedSessionId) {
      // debugger
      this.$store.dispatch("agendaDetailsById", publishedSessionId);
      $('.exhibit-list-popup').addClass('agenda-active');
    }, compareRooms(roomA, roomB) {
      const roomNumberA = this.extractRoomNumber(roomA);
      const roomNumberB = this.extractRoomNumber(roomB);

      // If both have room numbers, compare them numerically
      if (!isNaN(roomNumberA) && !isNaN(roomNumberB)) {
        return roomNumberA - roomNumberB;
      }

      // If one has a room number, prioritize it
      if (!isNaN(roomNumberA)) {
        return -1;
      } else if (!isNaN(roomNumberB)) {
        return 1;
      }

      // Compare alphabetically
      return (roomA || '').localeCompare(roomB || '');
    },

    // Helper function to extract room number from room name
    extractRoomNumber(room) {
      const match = (room || '').match(/\d+/);
      return match ? parseInt(match[0]) : NaN;
    },
    /*for fetching time based agenda
    groupAgendaByTimeold(agendaList) {
      let agendas = agendaList;
      const groups = {};
      if (agendas != null) {
        agendas.forEach(agenda => {
          //setting day state for date filter in intial load
          this.$store.state.dayState1 = agenda.earliestDate;

          let startTime = agenda.startDateTime;
          let room = agenda.room;
          console.log(room);
        if (!groups[startTime]) {
            groups[startTime] = [];
          }
          groups[startTime].push(agenda);
        });
        //return Object.values(groups);
        // Sort the groups by start time
        const sortedGroups = {};
        Object.keys(groups).sort().forEach(key => {
          sortedGroups[key] = groups[key];
        });
        return Object.values(sortedGroups);
      }
      return null;
    },*/
    groupAgendaByTime(agendaList) {
      let agendas = agendaList;
      const groups = {};

      if (agendas != null) {
        agendas.forEach(agenda => {
          this.$store.state.dayState1 = agenda.earliestDate;
          let startTime = agenda.startDateTime;

          if (!groups[startTime]) {
            groups[startTime] = [];
          }
          groups[startTime].push(agenda);
        });

        // Sort agendas within each time group: first by category order, then by publishedSessionId
        const categoryOrder = this.categoryOrder || [];
        const categoryIndex = (cat) => {
          const i = categoryOrder.indexOf(cat);
          return i === -1 ? categoryOrder.length : i;
        };
        Object.keys(groups).forEach(key => {
          groups[key].sort((a, b) => {
            const timeComparison = a.startDateTime.localeCompare(b.startDateTime);
            if (timeComparison !== 0) {
              return timeComparison;
            }
            // Sort by category order (first item in CategoryOrder appears first)
            const catOrderA = categoryIndex(a.category);
            const catOrderB = categoryIndex(b.category);
            if (catOrderA !== catOrderB) {
              return catOrderA - catOrderB;
            }
            // Same category: sort by publishedSessionId ASC
            const psIdA = Number(a.publishedSessionId);
            const psIdB = Number(b.publishedSessionId);
            if (!isNaN(psIdA) && !isNaN(psIdB)) {
              return psIdA - psIdB;
            }
            return (a.publishedSessionId || '').localeCompare(b.publishedSessionId || '');
          });
        });

        // Sort the groups by start time
        const sortedGroups = {};
        Object.keys(groups)
          .sort()
          .forEach(key => {
            sortedGroups[key] = groups[key];
          });

        return Object.values(sortedGroups);
      }

      return null;
    }

    ,
    /*intial categiry list*/
    getAllCategoryList() {
      //debugger
      axios.get(url.category_list_api)
        .then(response => {
          //debugger
          (this.categoryList = response.data);
        }).catch(err => {
          console.log(err.response);
        });
    },
    // getAllDayList() {
    //   //debugger
    //   axios.get(url.date_list_api)
    //     .then(response => {
    //       // Sort days by date chronologically
    //       const sortedDays = response.data.sort((a, b) => {
    //         const dateA = new Date(a.startDate);
    //         const dateB = new Date(b.startDate);
    //         return dateA - dateB;
    //       });
          
    //       this.days = sortedDays;
    //       // Set initial active day and state after days are loaded
    //       this.activeDay = this.days[0];
    //       this.$store.state.dayState = this.days[0].startDate;
    //       console.log('allDayResponse', sortedDays);
    //       console.log('activeDay set to:', this.activeDay.startDate);
    //       // Load agenda only after days are set
    //       this.getAllAgendaList();
    //     }).catch(err => {
    //       console.log(err.response);
    //     });
    // },
      getAllDayList() {
    axios.get(url.date_list_api)
      .then(response => {
        // Sort days by date chronologically
        const sortedDays = response.data.sort((a, b) => {
          const dateA = new Date(a.startDate);
          const dateB = new Date(b.startDate);
          return dateA - dateB;
        });
        
        this.days = sortedDays;
        // Set initial active day
        this.activeDay = this.days[0];
        
        // Load agenda data first, then filter by first day
        axios.get(url.initial_load_api)
          .then(agendaResponse => {
            // Store all agenda data first
            this.$store.commit("agendaData", agendaResponse.data);
            
            // Now filter by the first day's date
            const firstDayDate = this.days[0].startDate;
            this.$store.state.dayState = firstDayDate;
            this.$store.dispatch("agendaFilterByDay", firstDayDate);
            
            console.log('Days loaded:', sortedDays);
            console.log('Active day set to:', this.activeDay.startDate);
            console.log('Filtering agenda by:', firstDayDate);
          })
          .catch(err => {
            console.log('Error loading agenda:', err.response);
          });
          
      }).catch(err => {
        console.log('Error loading days:', err.response);
      });
  },
    showAgendaByCategoryAndDay: function (categoryName) {
      // debugger
      let selectedDayValue = this.$store.state.dayState;
      if (selectedDayValue == null) {
        selectedDayValue = this.$store.state.dayState1;
      }
      const objCategoryAndDay = {
        categoryName: categoryName,
        selectedDayValue: selectedDayValue
      };
      this.$store.dispatch("agendaFilterByCategoryAndDay", objCategoryAndDay);
      if (this.selectedCategory !== categoryName) {
        this.selectedCategory = categoryName;
      }
    },
    showAgendaByDay: function (selectedDay) {
      //debugger

      this.activeDay = this.days.find(day => day.startDate === selectedDay);
      //console.log(this.activeDay);
      //let day = this.days[0] === this.days[0] ? 1 : 2;
      //console.log(day)
      //const body = document.getElementsByClassName('active-bar');
      //body[0].classList.remove("tc-agenda-day-active");
      // body[1].classList.remove("tc-agenda-day-active");
      // document.getElementById(selectedDay).className = "test tc-agenda-day-active";

      this.$store.state.dayState = selectedDay;
      return this.$store.dispatch("agendaFilterByDay", selectedDay);
    },
    downloadICalendar() {
      // Build iCalendar content dynamically using Vue data
      const icalContent = `
BEGIN:VCALENDAR
PRODID:-//Microsoft Corporation//Outlook 11.0 MIMEDIR//EN
VERSION:2.0
METHOD:PUBLISH
BEGIN:VEVENT
DTSTART:${this.formatDateTime(this.startDate, this.startTime)} 
DTEND:${this.formatDateTime(this.startDate, this.endTime)}
LOCATION;ENCODING=QUOTED-PRINTABLE:${this.room}
TRANSP:OPAQUE
SEQUENCE:0
UID:${this.uid}
DTSTAMP:${this.formatDateTime(new Date())}
DESCRIPTION:${this.description}
SUMMARY:${this.companyName}
PRIORITY:5
CLASS:PUBLIC
BEGIN:VALARM
TRIGGER:PT1W
ACTION:DISPLAY
DESCRIPTION:Reminder
END:VALARM
END:VEVENT
END:VCALENDAR`;

      // Create a Blob with the iCalendar content
      const blob = new Blob([icalContent], { type: 'text/calendar;charset=utf-8' });

      // Create a download link
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = 'calendar.ics';

      // Append the link to the document and trigger a click event to start the download
      document.body.appendChild(link);
      link.click();

      // Clean up the temporary link element
      document.body.removeChild(link);
    },

    formatDateTime(date, time) {
      try {
        const dateTimeString = `${date}T${time}`;
        // Split the input date and time string
        const [datePart, timePart] = dateTimeString.split('T');
        const [month, day, year] = datePart.split('/');
        const [time1, meridiem] = timePart.split(' ');

        // Convert 12-hour time to 24-hour time
        let [hours, minutes] = time1.split(':');
        hours = parseInt(hours, 10) % 12 + (meridiem.toUpperCase() === 'PM' ? 12 : 0);

        // Pad single-digit values with leading zeros
        const formattedDateTime = `${year}${month.padStart(2, '0')}${day.padStart(2, '0')}T${hours.toString().padStart(2, '0')}:${minutes.padStart(2, '0')}:00`;

        return formattedDateTime;
      } catch (error) {
        console.error('Error formatting date and time:', error.message);
        return ''; // Handle invalid input by returning an empty string or another default value
      }
    },
    removeNbsp(text) {
            // Replace &nbsp; with an empty string
            return text.replace(/&nbsp;/g, '');
        },
    formatDateToMonthDayYear(dateString) {
      // Parse the date string in DD - MM - YYYY format (with spaces)
      const parts = dateString.split('-').map(part => part.trim());
      
      if (parts.length !== 3) {
        console.error('Invalid date format:', dateString);
        return dateString;
      }
      
      const day = parseInt(parts[0], 10);
      const month = parseInt(parts[1], 10);
      const year = parseInt(parts[2], 10);
      
      // Check if values are valid
      if (isNaN(month) || isNaN(day) || isNaN(year)) {
        console.error('Invalid date values:', dateString);
        return dateString;
      }
      
      // Month names array
      const monthNames = [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
      ];
      
      // Return formatted date string
      return `${monthNames[month - 1]} ${day}, ${year}`;
    }


  }
};





</script>
<style>
#options .option-combo ul {
  margin: 0;
  display: inline-block;
  width: calc(100% - 200px);
}

img.filter-block-logo {
  max-width: 150px;
  width: 100%;
}

.subject-outer p {
  font-size: 15px;
}

.wrap-programme {
  padding: 40px 0 0;
}

.date-filter-block {
  display: flex;
  align-items: center;
}

.sub-sp-block {
  width: 80%;
}

@media (max-width:1199px) {
  .date-filter-block {
    display: block;
  }

  img.filter-block-logo {
    display: block;
    margin: 0 auto 20px !important;
    max-width: 200px;
  }

  #options .option-combo ul {
    width: 100%;
  }

  .active {
    display: block;
  }
}
</style>
